import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { DeleteRecipeInput } from './DeleteRecipeInput';
import { DeleteRecipeOutput } from './DeleteRecipeOutput';

export class DeleteRecipeService extends HttpServiceBase {

  handle = (input: DeleteRecipeInput): Promise<Result<DeleteRecipeOutput> | null> => {
    const promise = this.http.delete<Result<DeleteRecipeOutput>>(`${this.baseUrlSislogApi}/v2/recipe/${input.recipeId}`);
    return promise;
  }

  handleWithExtraParams = (input: DeleteRecipeInput, processPrescriptionState?: boolean): Promise<Result<DeleteRecipeOutput> | null> => {
    const promise = this.http.delete<Result<DeleteRecipeOutput>>(
      `${this.baseUrlSislogApi}/v2/recipe/${input.recipeId}/with-extra-params?process-prescription-state=${processPrescriptionState || 'false'}`);
    return promise;
  }
}